import React from 'react';
import PropTypes from 'prop-types';
import {useRouteMatch} from 'react-router-dom';
import {Formik} from 'formik';
import TabSurveyAssetsView from './TabSurveyAssets-view';
import {checkRequiredValues} from 'common/utils/form/checkRequiredValues';
import {normalizeFormValues} from 'common/utils/form/normalizeFormValues';
import {pathnames as P} from 'common/constants/pathnames';
import {messages as M} from '../../constants/messages';

const TabSurveyAssets = ({
                           showLittlePopup,
                           saveRow,
                           cities,
                           streets,
                           updateStreets,
                           saveValues,
                           previousValues,
                           ...props
                         }) => {

  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_ID);

  const initialValues = {
    cityID: null,
    streetID: null,
    houseNum: '',
    houseRegisteredArea: '',
    houseRoomCount: '',
    floor: '',
    buildingFloorsCount: '',
    buildYear: '',
    houseParking: null,
    buildingElevator: null,
    houseYard: null,
    houseStorage: null,
    houseRoof: null,
    houseBalconyCount: '',
    askingPrice: '',
    marketingFactor: '',
  };

  const validate = values => {
    const {
      cityID,
      streetID
    } = values;

    return checkRequiredValues({cityID, streetID}, {});
  };

  const handleSubmit = (values, {setSubmitting, resetForm}) => {
    const data = {
      shumaId,
      ...normalizeFormValues(values),
    };
    return saveRow(data)
      .then((response) => {
        const message = response.data.errorCode === -1
          ? M.FAILED : M.GRID_ROW_SAVED;
        showLittlePopup(message)
      })
      .catch(() => showLittlePopup(M.FAILED))
      .then(resetForm(initialValues))
      .finally(setSubmitting(false))
  };

  const changeValue = key => value => saveValues({[key]: value});

  const handleChangeValue = key => event => changeValue(key)(event.target.value);

  const handleCityChange = formikProps => selected => {
    const {values: {city}, setFieldValue} = formikProps;
    if (!city || city.value !== selected.value) {
      changeValue('cityID')(selected);
      setFieldValue('streetID', null);
      if (Boolean(selected.value)) {
        updateStreets(selected.value);
      } else {
        handleCityReset(formikProps)();
      }
    }
  };

  const handleCityReset = formikProps => () => {
    const {setFieldValue} = formikProps;
    changeValue('cityID')(null);
    setFieldValue('cityID', null);
    setFieldValue('streetID', null);
  };

  const handleChangeAndLimitValue = (key, limiter) => value => {
    const limitedValue = limiter(value);
    changeValue(key)(limitedValue);

    return limitedValue;
  };

  return (
    <Formik
      initialValues={initialValues}
      validate={validate}
      onSubmit={handleSubmit}
      validateOnChange={true}
      validateOnBlur={false}
    >
      {(formikProps) => (
        <TabSurveyAssetsView
          {...formikProps}
          options={{cities, streets}}
          cityChangeProps={{
            onChange: handleCityChange(formikProps),
            onReset: handleCityReset(formikProps),
          }}
          onCityChange={handleCityChange(formikProps)}
          onEventChange={handleChangeValue}
          onSelectorChange={changeValue}
          onChangeAndLimit={handleChangeAndLimitValue}
          {...props}
        />
      )}
    </Formik>
  );
};

TabSurveyAssets.propTypes = {
  showLittlePopup: PropTypes.func,
  saveRow: PropTypes.func,
  cities: PropTypes.array,
  streets: PropTypes.array,
  updateStreets: PropTypes.func,
};

export default TabSurveyAssets;
